import { Box, UnstyledButton, Loader } from "@mantine/core";
import { useColors } from "@utils/useColors";
import React, { ComponentProps, FC } from "react";

interface CompleteSetupButtonProps
  extends ComponentProps<typeof UnstyledButton<"button">> {
  isLoading: boolean;
}

export const CompleteSetupButton: FC<CompleteSetupButtonProps> = (props) => {
  const { onMouseDown, onMouseUp, isLoading, ...other } = props;
  const [clicked, setClicked] = React.useState(false);

  const colors = useColors();

  const handleMouseDown = (
    event: React.MouseEvent<HTMLButtonElement>,
  ): void => {
    setClicked(true);
    onMouseDown?.(event);
  };

  const handleMouseUp = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setClicked(false);
    onMouseUp?.(event);
  };

  return (
    <UnstyledButton
      {...other}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      style={{
        cursor: "pointer",
        position: "relative",
        border: "none",
        outline: "none",
        background: "none",
        padding: 0,
        ...(clicked && {
          // move the button down when clicked and add transition
          transform: "scale(0.998) translateY(.7px)",
          transition: "transform 0.04s ease-in-out",
        }),
        ...other.style,
      }}
    >
      <svg
        width="269"
        height="77"
        viewBox="0 0 269 77"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="2.08462"
          y="2.08462"
          width="264.323"
          height="72.8308"
          fill="#0C99F1"
          stroke="#012B60"
          strokeWidth="3.83077"
        />
        <g filter="url(#filter0_f_89_288)">
          <path
            d="M139.992 42.7463C83.2966 43.1709 26.9843 30.8924 5.91504 24.7001V72.4693H262.577V24.7001C245.338 30.5386 196.687 42.3217 139.992 42.7463Z"
            fill="url(#paint0_linear_89_288)"
          />
        </g>
        <rect
          x="4"
          y="61.3226"
          width="260.492"
          height="11.6769"
          fill="#0D5785"
        />
        <defs>
          <filter
            id="filter0_f_89_288"
            x="4.63812"
            y="23.4232"
            width="259.215"
            height="50.3231"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="0.638462"
              result="effect1_foregroundBlur_89_288"
            />
          </filter>
          <linearGradient
            id="paint0_linear_89_288"
            x1="137.438"
            y1="71.9386"
            x2="137.438"
            y2="58.1386"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0C99F1" />
            <stop offset="1" stopColor="#0174DF" />
          </linearGradient>
        </defs>
      </svg>
      <Box
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {isLoading ? <Loader color={colors.gray20} /> : props.children}
      </Box>
    </UnstyledButton>
  );
};
